export default __webpack_public_path__ + "static/media/6.f8ca3263.png";